module.exports = __webpack_public_path__ + "static/media/GulinareSeries5 .b7e40065.jpg";